import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase, ref, set, push, get, child, update, query, orderByChild, equalTo } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyC-F6cg3-D2A_AEtx12wur54eiP2bvQgIY",
  authDomain: "loinhand-549aa.firebaseapp.com",
  databaseURL: "https://loinhand-549aa-default-rtdb.firebaseio.com",
  projectId: "loinhand-549aa",
  storageBucket: "loinhand-549aa.firebasestorage.app",
  messagingSenderId: "124788577320",
  appId: "1:124788577320:web:08d4faa446e78a4b97111d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export { ref, set, push, get, child, update, query, orderByChild, equalTo };